<template>
	<v-container fluid class="pt-0">
		<v-row>
			<v-col cols="12" xl="12" lg="12" md="12" class="mb-8">
				<v-tabs>
					<v-tab>{{ $t('titles.preregistrationInformations') }}</v-tab>
					<v-tab-item>
						<v-card flat outlined>
							<v-card-text>
								<v-row wrap>
									<v-col cols="12" class="pt-0 pb-0">
										<v-row class="pt-0">
											<v-col cols="12" class="d-flex justify-end pb-0 pt-0">
												<v-btn
													v-if="!inEditMode"
													class="ml-2"
													color="warning"
													@click="deleteClick(preregistration.id)"
												>
													<v-icon small>fa-trash</v-icon>&nbsp;{{ $t('buttons.delete') }}
												</v-btn>
												<v-btn
													v-if="!inEditMode"
													class="ml-2"
													color="primary"
													@click="copyClick(preregistration.id)"
												>
													<v-icon small>fa-copy</v-icon>&nbsp;{{ $t('buttons.copy') }}
												</v-btn>
												<v-btn
													v-if="inEditMode"
													class="ml-2 mr-2"
													color="primary"
													@click="saveClick(null)"
												>
													<v-icon small>fa-save</v-icon>&nbsp;{{ $t('buttons.save') }}
												</v-btn>
												<v-btn
													v-if="!inEditMode"
													class="ml-2 mr-2"
													color="primary"
													@click="editClick()"
												>
													<v-icon small>fa-edit</v-icon>&nbsp;{{ $t('buttons.edit') }}
												</v-btn>
												<v-btn class="mr-2" color="basicButton" @click="backClick">
													<v-icon small>fa-reply</v-icon>&nbsp;{{ $t('buttons.back') }}
												</v-btn>
											</v-col>
										</v-row>
									</v-col>
									<v-flex lg6 xs12 sm12 md12 class="pt-0 pa-2">
										<v-col cols="12">
											<div :class="['text-h6', 'pa-2', 'pl-0']">
												{{ $t('titles.candidateInformations') }}
											</div>
										</v-col>
										<v-col cols="12" v-if="$route.params.id != 0">
											<InputField
												:disabled="true"
												v-model="preregistration.id"
												:label="'* ' + $t('fields.id')"
											></InputField>
										</v-col>
										<v-col cols="12" v-if="$route.params.id != 0">
											<Dropdown
												:disabled="true"
												v-model="preregistration.author_id"
												:ajax="true"
												:data="'users'"
												:label="$t('fields.author')"
											></Dropdown>
										</v-col>
										<v-col cols="12" v-if="inEditMode">
											<v-row no-gutters>
												<v-col cols="11">
													<Dropdown
														:readonly="!inEditMode"
														v-model="preregistration.candidate_id"
														:ajax="true"
														:data="'candidates'"
														:clearable="true"
														:errorBorder="!preregistrationValidation.candidate_id"
														:label="$t('fields.existingCandidate')"
													></Dropdown>
												</v-col>
												<v-col v-if="preregistration.candidate_id" cols="1" class="pl-4 pt-3">
													<v-tooltip bottom>
														<template v-slot:activator="{ on, attrs }">
															<v-btn
																icon
																v-bind="attrs"
																@click="editCandidate()"
																v-on="on"
															>
																<v-icon>fas fa-user-pen</v-icon>
															</v-btn>
														</template>
														<span>{{ $t('tooltips.editCandidate') }}</span>
													</v-tooltip>
												</v-col>
											</v-row>
										</v-col>
										<v-col cols="12" v-else>
											<Dropdown
												:readonly="!inEditMode"
												v-model="preregistration.candidate_id"
												:ajax="true"
												:data="'candidates'"
												:clearable="true"
												:errorBorder="!preregistrationValidation.candidate_id"
												:label="$t('fields.existingCandidate')"
											></Dropdown>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												:disabled="candidateExists"
												v-model="preregistration.first_name"
												:errorBorder="!preregistrationValidation.first_name"
												:label="'* ' + $t('fields.firstName')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												:disabled="candidateExists"
												v-model="preregistration.last_name"
												:errorBorder="!preregistrationValidation.last_name"
												:label="'* ' + $t('fields.lastName')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												:disabled="candidateExists"
												v-model="preregistration.email"
												:errorBorder="!preregistrationValidation.email"
												:label="'* ' + $t('fields.email')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<InputField
												:readonly="!inEditMode"
												:disabled="candidateExists"
												v-model="preregistration.phone"
												:errorBorder="!preregistrationValidation.phone"
												:label="'* ' + $t('fields.phone')"
											></InputField>
										</v-col>
										<v-col cols="12" v-if="inEditMode">
											<v-row no-gutters>
												<v-col cols="11">
													<InputField
														:readonly="!inEditMode"
														:disabled="candidateExists"
														v-model="preregistration.oib"
														:errorBorder="!preregistrationValidation.oib"
														:label="$t('fields.oib')"
													></InputField>
												</v-col>
												<v-col
													v-if="preregistration.oib !== null && preregistration.oib !== ''"
													cols="1"
													class="pl-4 pt-3"
												>
													<v-tooltip bottom>
														<template v-slot:activator="{ on, attrs }">
															<v-btn
																icon
																:disabled="candidateExists"
																v-bind="attrs"
																@click="candidateExistsClick()"
																v-on="on"
															>
																<v-icon>fas fa-magnifying-glass</v-icon>
															</v-btn>
														</template>
														<span>{{
															$t('tooltips.checkIfCandidateExistsInDatabase')
														}}</span>
													</v-tooltip>
												</v-col>
											</v-row>
										</v-col>
										<v-col cols="12" v-else>
											<InputField
												:readonly="!inEditMode"
												:disabled="candidateExists"
												v-model="preregistration.oib"
												:errorBorder="!preregistrationValidation.oib"
												:label="$t('fields.oib')"
											></InputField>
										</v-col>
										<v-col cols="12">
											<Dropdown
												:readonly="!inEditMode"
												:disabled="preregistration.candidate_id != null"
												v-model="preregistration.partner_id"
												:ajax="true"
												:clearable="true"
												:data="'partners-buyers'"
												:errorBorder="!preregistrationValidation.partner_id"
												:label="$t('fields.company')"
											></Dropdown>
										</v-col>
										<v-col cols="12">
											<Dropdown3
												:readonly="!inEditMode"
												v-model="preregistration.login_type_id"
												:ajax="true"
												:clearable="true"
												:data="'preregistration-login-types'"
												:errorBorder="!preregistrationValidation.login_type_id"
												:label="'* ' + $t('fields.loginType')"
											></Dropdown3>
										</v-col>
										<v-col cols="12">
											<CheckBox
												:readonly="!inEditMode"
												v-model="preregistration.notified"
												:label="$t('fields.notified')"
											></CheckBox>
										</v-col>
										<v-col
											cols="12"
											v-if="
												preregistration.candidate_id == null &&
												$route.params.id != 0 &&
												!inEditMode
											"
											@click="addToTheBaseClick()"
										>
											<v-btn>{{ $t('buttons.addToTheBase') }}</v-btn>
										</v-col>
									</v-flex>
									<v-flex lg6 xs12 sm12 md12 class="pt-0 pa-2">
										<v-col cols="12">
											<div :class="['text-h6', 'pa-2', 'pl-0']">
												{{ $t('titles.courseInformations') }}
											</div>
										</v-col>
										<v-col cols="12">
											<Dropdown
												:readonly="!inEditMode"
												v-model="preregistration.course_id"
												:ajax="true"
												:clearable="true"
												:data="'courses'"
												:errorBorder="!preregistrationValidation.course_id"
												:label="'* ' + $t('fields.course')"
											></Dropdown>
										</v-col>
										<v-col cols="12" v-if="courseExists">
											<Dropdown
												:readonly="!inEditMode"
												:disabled="!courseExists"
												v-model="preregistration.planned_course_id"
												:ajax="courseExists"
												:clearable="true"
												:data="'planned-courses/' + preregistration.course_id"
												:apiCallOnSelect="true"
												:errorBorder="!preregistrationValidation.planned_course_id"
												:label="$t('fields.plannedCourse')"
												@get-item="setPlannedCourseData"
											></Dropdown>
										</v-col>
										<v-col cols="12">
											<DatePicker
												:readonly="!inEditMode"
												:disabled="preregistration.planned_course_id != null"
												v-model="preregistration.start_date"
												:errorBorder="!preregistrationValidation.start_date"
												:date-label="$t('fields.startDate')"
											></DatePicker>
										</v-col>
										<v-col cols="12">
											<Dropdown3
												:readonly="!inEditMode"
												:disabled="preregistration.planned_course_id != null"
												v-model="preregistration.office_id"
												:ajax="true"
												:clearable="true"
												:data="'offices'"
												:errorBorder="!preregistrationValidation.office_id"
												:label="$t('fields.office')"
											></Dropdown3>
										</v-col>

										<v-col cols="12">
											<TextArea
												:readonly="!inEditMode"
												v-model="preregistration.note"
												:errorBorder="!preregistrationValidation.note"
												:label="$t('fields.note')"
												rows="5"
											></TextArea>
										</v-col>
										<v-col cols="12">
											<CheckBox
												:readonly="!inEditMode"
												v-model="preregistration.correctional"
												:label="$t('fields.correctional')"
											></CheckBox>
										</v-col>
									</v-flex>
								</v-row>
							</v-card-text>
						</v-card>
					</v-tab-item>
				</v-tabs>
			</v-col>
		</v-row>
		<v-row>
			<v-col>
				<Modal :show-modal="showModal">
					<NewCandidate
						:newCandidate="newCandidate"
						:inEditMode="true"
						:editingExisting="editingExisting"
						:candidateId="candidateId"
						@close="closeModal"
						@reloadData="reloadData"
						@reloadExistingCandidateData="getExistingCandidateData"
					></NewCandidate>
				</Modal>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import InputField from '../../trinkets/InputField';
import CheckBox from '../../trinkets/CheckBox';
import Preregistration from '../../../models/Preregistration';
import Dropdown from '../../trinkets/Dropdown';
import Dropdown3 from '../../trinkets/Dropdown3';
import DatePicker from '../../trinkets/DatePicker';
import TextArea from '../../trinkets/TextArea';
import Modal from '../../trinkets/Modal';
import NewCandidate from './NewCandidate';
import Candidate from '../../../models/Candidate';

export default {
	name: 'Preregistration',
	components: {
		CheckBox,
		InputField,
		DatePicker,
		Dropdown,
		Dropdown3,
		TextArea,
		Modal,
		NewCandidate,
	},
	data: function () {
		return {
			preregistration: new Preregistration({ id: this.$route.params.id, author_id: this.$myStore.state.user.id }),
			preregistrationValidation: new Preregistration({}, true),
			newCandidate: new Candidate({ id: 0 }),
			existingCandidate: new Candidate({}),
			initialLoad: false,
			inEditMode: false,
			lockKey: 'preregistration',
			lockTimer: null,
			showModal: false,
			candidateExists: false,
			courseExists: false,
			editingExisting: false,
			candidateId: null,
		};
	},
	watch: {
		'preregistration.candidate_id': function (newVal) {
			if (newVal !== null) {
				this.candidateExists = true;
				this.getExistingCandidateData();
			} else {
				this.candidateExists = false;
				this.preregistration.first_name = '';
				this.preregistration.last_name = '';
				this.preregistration.email = '';
				this.preregistration.phone = '';
				this.preregistration.oib = '';
				this.preregistration.partner_id = null;
			}
		},
		'preregistration.course_id': function (newVal) {
			if (newVal !== null) {
				this.courseExists = true;
			} else {
				this.courseExists = false;
				this.preregistration.planned_course_id = null;
				this.preregistration.start_date = null;
				this.preregistration.office_id = null;
			}
		},
	},
	methods: {
		editClick() {
			let vm = this;
			this.$setLock(this, this.lockKey + '|' + this.preregistration.id, (data) => {
				if (data.success) {
					vm.inEditMode = true;
					vm.lockTimer = setInterval(() => {
						vm.$setLock(vm, vm.lockKey + '|' + vm.preregistration.id);
					}, 10000);
				} else {
					vm.$alert(
						vm
							.$t('alerts.recordLocked')
							.split('%name%')
							.join(data.locked_by.first_name + ' ' + data.locked_by.last_name)
					);
				}
			});
		},
		backClick() {
			this.$router.push('/preregistrations');
		},
		copyClick() {
			const routeData = this.$router.resolve({
				name: 'preregistration',
				params: {
					id: 0,
				},
				query: {
					preregistration: this.preregistration.id,
				},
			});

			const fullUrl = routeData.href;
			window.open(fullUrl, '_blank');
		},
		closeModal() {
			this.candidateId = null;
			this.showModal = false;
			this.editingExisting = false;
		},
		addToTheBaseClick() {
			this.copyProps();
			this.showModal = true;
		},
		editCandidate() {
			this.candidateId = this.preregistration.candidate_id;
			this.editingExisting = true;
			this.showModal = true;
		},
		copyProps() {
			for (const prop in this.preregistration) {
				if (
					this.preregistration.hasOwnProperty(prop) &&
					this.newCandidate.hasOwnProperty(prop) &&
					prop != 'id'
				) {
					this.newCandidate[prop] = this.preregistration[prop];
				}
			}
			this.newCandidate.preregistration_id = this.preregistration.id;
		},

		deleteClick(id) {
			let vm = this;
			this.$verify(this.$t('alerts.deletionQuestion'), (result) => {
				if (result) {
					vm.$APICall(
						'delete',
						'preregistrations/' + id + '/delete',
						{ preregistration_id: id },
						(data, success) => {
							if (success) {
								vm.$notify(vm.$t('alerts.basicDelete'));
								vm.backClick();
							} else {
								vm.$alert(vm.$t('alerts.basicError'));
							}
						}
					);
				}
			});
		},
		candidateExistsClick() {
			let vm = this;
			this.$APICall(
				'get',
				'candidates/' + this.preregistration.oib + '/oib',
				{},
				(data, success) => {
					if (success) {
						if (data.error == 422) {
							vm.$notify(
								vm
									.$t('alerts.candidateExistInDatabase')
									.replace('%id%', data.id)
									.replace('%name%', data.full_name)
							);
							return;
						}
						vm.$notify(vm.$t('alerts.candidateDontExistInDatabase'));
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		setPlannedCourseData(data) {
			this.preregistration.start_date = data.start_date;
			this.preregistration.office_id = data.office_id;
		},
		saveClick(after = null) {
			let success = true;
			let errorMessages = '';

			if (this.preregistration.first_name == '') {
				success = false;
				this.preregistrationValidation.first_name = false;
			} else {
				if (this.preregistration.first_name.length > 50) {
					this.preregistrationValidation.first_name = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.firstName'))
							.replace('%length%', '50') + '<br />';
				} else {
					this.preregistrationValidation.first_name = true;
				}
			}

			if (this.preregistration.last_name == '') {
				success = false;
				this.preregistrationValidation.last_name = false;
			} else {
				if (this.preregistration.last_name.length > 50) {
					this.preregistrationValidation.last_name = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.lastName'))
							.replace('%length%', '50') + '<br />';
				} else {
					this.preregistrationValidation.last_name = true;
				}
			}

			if (this.preregistration.phone == '') {
				success = false;
				this.preregistrationValidation.phone = false;
			} else {
				if (this.preregistration.phone.length > 20) {
					this.preregistrationValidation.phone = false;
					errorMessages +=
						this.$t('alerts.lengthError')
							.replace('%field%', this.$t('fields.phone'))
							.replace('%length%', '20') + '<br />';
				} else {
					this.preregistrationValidation.phone = true;
				}
			}

			if (this.preregistration.email == '') {
				success = false;
				this.preregistrationValidation.email = false;
			} else {
				if (!this.$checkEmail(this.preregistration.email)) {
					this.preregistrationValidation.email = false;
					errorMessages += this.$t('alerts.formatError').split('%value%').join('E-mail') + '<br />';
				} else {
					this.preregistrationValidation.email = true;
				}
			}

			if (
				this.preregistration.oib !== null &&
				this.preregistration.oib !== '' &&
				this.preregistration.oib.length > 20
			) {
				success = false;
				this.preregistrationValidation.oib = false;
				errorMessages +=
					this.$t('alerts.lengthError').replace('%field%', this.$t('fields.oib')).replace('%length%', '20') +
					'<br />';
			} else {
				this.preregistrationValidation.oib = true;
			}

			if (!this.preregistration.course_id) {
				success = false;
				this.preregistrationValidation.course_id = false;
			} else {
				this.preregistrationValidation.course_id = true;
			}

			if (!this.preregistration.login_type_id) {
				success = false;
				this.preregistrationValidation.login_type_id = false;
			} else {
				this.preregistrationValidation.login_type_id = true;
			}

			if (this.preregistration.note != null && this.preregistration.note.length > 500) {
				this.preregistrationValidation.note = false;
				errorMessages +=
					this.$t('alerts.lengthError')
						.replace('%field%', this.$t('fields.note'))
						.replace('%length%', '500') + '<br />';
			} else {
				this.preregistrationValidation.note = true;
			}

			if (errorMessages !== '') {
				this.$alert(errorMessages);
				success = false;
			}

			if (success) {
				let vm = this;
				let action = 'post';
				let addition = '';
				// A new preregistration has id 0. An existing one must have a valid
				// positive numeric id; anything else (undefined, null, 'undefined',
				// NaN) means the route/state is broken - abort instead of firing
				// PUT preregistrations/undefined, which crashes the API.
				const numericId = Number(vm.preregistration.id);
				const isNew = vm.preregistration.id == 0;
				if (!isNew && (!Number.isInteger(numericId) || numericId <= 0)) {
					this.$alert(this.$t('alerts.basicError'));
					return;
				}
				if (!isNew) {
					action = 'put';
					addition = '/' + numericId;
				}
				if (this.preregistration.planned_course_id) {
					this.preregistration.has_plan = true;
				} else {
					this.preregistration.has_plan = false;
				}
				if (this.$myStore.state.user.offices.includes(this.preregistration.office_id)) {
					this.preregistration.seen = true;
				}
				this.$APICall(action, 'preregistrations' + addition, this.preregistration, (data, success) => {
					if (success) {
						vm.inEditMode = false;
						if (vm.preregistration.id == 0) {
							vm.$notify(vm.$t('alerts.basicAdd'));
						} else {
							vm.$notify(vm.$t('alerts.basicUpdate'));
						}
						if (after !== null) {
							after();
						} else {
							vm.backClick();
						}
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				});
			}
		},
		getExistingCandidateData() {
			let vm = this;
			this.$APICall(
				'get',
				'candidates/' + this.preregistration.candidate_id,
				{},
				(data, success) => {
					if (success) {
						this.existingCandidate = JSON.parse(JSON.stringify(data));
						vm.preregistration.first_name = data.first_name;
						vm.preregistration.last_name = data.last_name;
						vm.preregistration.phone = data.phone;
						vm.preregistration.email = data.email;
						vm.preregistration.oib = data.oib;
						vm.preregistration.partner_id = data.partner_id;
					} else {
						vm.$alert(vm.$t('alerts.basicError'));
					}
				},
				false
			);
		},
		reloadData() {
			let vm = this;
			this.$APICall('get', 'preregistrations/' + this.preregistration.id, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.preregistration = usableData;
					vm.$myStore.commit('setBreadcrumbs', [
						{
							text: vm.$t('modules.preregistrations'),
							href: '/#/preregistrations',
							disabled: false,
						},
						{
							text:
								vm.preregistration.first_name +
								' ' +
								vm.preregistration.last_name +
								' (' +
								vm.preregistration.id +
								')',
							href: '/#/preregistrations/' + vm.preregistration.id,
							disabled: true,
						},
					]);
					if (
						vm.$myStore.state.user.offices.includes(vm.preregistration.office_id) &&
						!this.preregistration.seen
					) {
						vm.setSeen();
					}
					vm.$nextTick(() => {
						vm.initialLoad = true;
					});
				}
			});
		},
		setSeen() {
			this.$APICall('put', 'preregistrations/' + this.preregistration.id + '/seen', {}, (data, success) => {
				// if (success) {
				// console.log('Predupis ' + this.preregistration.id + ' pročitan.');
				// }
			});
		},
	},
	beforeRouteLeave(to, from, next) {
		let vm = this;
		if (this.inEditMode) {
			this.$verify(this.$t('alerts.leaveQuestion'), (result) => {
				if (result) {
					if (vm.lockTimer !== null) clearInterval(vm.lockTimer);
					vm.$removeLock(vm, vm.lockKey + '|' + vm.preregistration.id);
					next(true);
				} else {
					next(false);
				}
			});
		} else {
			if (this.lockTimer !== null) clearInterval(this.lockTimer);
			vm.$removeLock(vm, vm.lockKey + '|' + vm.preregistration.id);
			next(true);
		}
	},
	created() {
		if (this.$route.query.preregistration) {
			let vm = this;

			this.$APICall('get', 'preregistrations/' + this.$route.query.preregistration, {}, (data, success) => {
				if (success) {
					let usableData = JSON.parse(JSON.stringify(data));
					vm.preregistration = usableData;
					vm.preregistration.enrolled = 0;
					vm.preregistration.manual_enrollment = 0;
					vm.preregistration.payment_contract_used_item_id = null;
					vm.preregistration.passed = 0;
					vm.preregistration.testimonial_number = null;
					vm.preregistration.active = 1;
					vm.preregistration.id = 0;
					vm.$nextTick(() => {
						vm.initialLoad = true;
					});
				}
			});
		}
	},
	mounted() {
		if (!this.$myStore.state.loggedIn) {
			this.$router.replace('/login');
		}
		if (this.preregistration.id != 0) {
			this.reloadData();
		} else {
			this.$myStore.commit('setBreadcrumbs', [
				{
					text: this.$t('modules.preregistrations'),
					href: '/#/preregistrations',
					disabled: false,
				},
				{
					text: this.$t('modules.newPreregistration'),
					href: '/#/preregistrations/0',
					disabled: true,
				},
			]);
			this.inEditMode = true;
			this.initialLoad = true;
		}
	},
};
</script>

<style scoped></style>
